<template>
<div class="container-fluid">

<div class="card border-primary mb-3">
  <h4 class="card-header  bg-primary text-white">STAMPA CODICE A BARRE GIFT CARD</h4>
  <div class="card-body">
    <form v-on:submit.prevent="submit()">

        <div class="form-group row">    
            <label for="inputCode" class="col-sm-2 col-form-label">CODICE GIFT CARD</label>
            <div class="col-sm-10">
            <input autocomplete="off" required v-focus type="text" class="form-control" id="inputCode" v-model="GiftCard.gc_code">
            </div>
        </div>  
            
        <div class="form-group row ml-4">
            <div class="col-sm-10">
            <button :disabled="spinner" type="submit" class="btn btn-primary">
                <span v-if="spinner" class="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true"></span>
                STAMPA</button>
            </div>
        </div>
  
    </form>


<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  </div>
</div>




</div>
</template>
<script>
import { mapGetters }      from 'vuex';
import alertBox            from '@/components/common/AlertBox.vue'
export default {

components  : {alertBox},
props: [],

data () {
    return {

      
      GiftCard      : {}, 
      
      
      spinner       : false,
      

     
      device_list     : [],
      selected_device : {},
      devices         : [],
      device_uid      : '',
     
      FS         : '^FS',
      SF         : '^XA^CI0,21,36',
      qty        : '^PQ1',
      EF         : '^XZ',
      msg        : {
            title : '',
            body  : '',
            type  : 0
      }

    
      
    }
  },
    directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  computed: 
  {
    ...mapGetters(['company']) ,   
  },
  mounted()
    {      
      this.setup()
    },
  methods: 
    {
    submit()
    {
        this.printLabel()
    },  
    printLabel()
    {

    this.msg.title  = ''       
    let zpl         = ''
    let dataToWrite = this.SF
    zpl             = '^FO55,40^AQN,56,24^FD' + this.GiftCard.gc_code   
    dataToWrite     += zpl + this.FS 
    zpl             = '^FO55,110^BY1,2,100^BCN,100,N,N,N^FD' +  this.GiftCard.gc_code   
    dataToWrite     += zpl + this.FS 
    dataToWrite     += this.qty 
    dataToWrite     += this.EF    

    if(this.device_uid=='')
    {
               
        this.msg.title = 'ATTENZIONE '
        this.msg.type = 1
        this.msg.body = 'Selezionare una stampante.'
        return
    }
    
    this.msg.title = ''
    
    //this.writeToSelectedPrinterTest('~hs')
    
    this.selected_device.send(dataToWrite, undefined, this.errorCallback);
    
    },
    
    onDeviceSelected(selected)
    {
   
    this.msg.title = ''
	  for(var i = 0; i < this.devices.length; ++i)
    {
      if(selected == this.devices[i].uid)
      {
        this.selected_device = this.devices[i];
          return;
      }
	  }
    },

    errorCallback (errorMessage)
    {
	    this.msg.title = 'ATTENZIONE '
        this.msg.type = 1
        this.msg.body = errorMessage

    },
    setup()
    {
      
	  //Get the default device from the application as a first step. Discovery takes longer to complete.
    
    //var _this = this
    
            BrowserPrint.getDefaultDevice("printer", (device) =>
    			{
                
                //alert("Devices: " + JSON.stringify(device)) 
                //Add device to list of devices and to html select element
                
				        this.selected_device =  JSON.stringify(device)
                this.devices.push(device);               
                this.device_uid = this.devices[0].uid
               
                this.onDeviceSelected(this.devices[0].uid)

				//Discover any other devices available to the application
      
    
				
			}, (err) =>{
                let msg = err ? err : 'Zebra Browser Print non avviato.'
        
                this.msg.title = 'ATTENZIONE *'
                this.msg.body = msg
                this.msg.type = 1
          
				
      })
      


    },
    
    },

    
  
  
  }

</script>

<style scoped>


</style>

